import React from 'react';
import { Pool } from '../../../components/LiquidityMiningPool';
import { LiquidityMiningPoolList } from '../../../components/LiquidityMiningPoolList';

export const AwaitingPools: React.FC = () => {
  return (
    <LiquidityMiningPoolList
      title="Awaiting pools"
      subTitle="List of awaiting pools (new pools can take a few minutes to show up here)"
      filter={(pool: Pool): boolean => {
        return pool.start.getTime() === 0;
      }}
    />
  );
};
